import { DetailItem } from '@components/common/ReusableInfoCard.tsx'

type SensorsDetails = {
  title: string
  icon: string
  items: DetailItem[]
  footerNote: string
}

export const infoCards: SensorsDetails[] = []
